var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "carzRangeSearchPagination" }, [
    _c(
      "button",
      {
        staticClass: "carzRangeSearchPagination__prev",
        attrs: { type: "button", disabled: _vm.isPrevDisabled },
        on: { click: _vm.prevPage },
      },
      [
        _vm._t("prevContent", [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 256 512",
                fill: "currentColor",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M231.293 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L70.393 256 251.092 74.87c4.686-4.686 4.686-12.284 0-16.971L231.293 38.1c-4.686-4.686-12.284-4.686-16.971 0L4.908 247.515c-4.686 4.686-4.686 12.284 0 16.971L214.322 473.9c4.687 4.686 12.285 4.686 16.971-.001z",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [_vm._v("Previous")]),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "carzRangeSearchPagination__next",
        attrs: { type: "button", disabled: _vm.isNextDisabled },
        on: { click: _vm.nextPage },
      },
      [
        _vm._t("nextContent", [
          _c(
            "svg",
            {
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 256 512",
                fill: "currentColor",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M24.707 38.101L4.908 57.899c-4.686 4.686-4.686 12.284 0 16.971L185.607 256 4.908 437.13c-4.686 4.686-4.686 12.284 0 16.971L24.707 473.9c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L41.678 38.101c-4.687-4.687-12.285-4.687-16.971 0z",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "sr-only" }, [_vm._v("Next")]),
        ]),
      ],
      2
    ),
    _vm._v(" "),
    _c("div", { staticClass: "carzRangeSearchPagination__context" }, [
      _vm._v("\n        " + _vm._s(_vm.pagesContext) + "\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }